// extracted by mini-css-extract-plugin
module.exports = {"addButton":"styles_addButton__bnClT","newColumnButtons":"styles_newColumnButtons__39blv"};